import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ChatRoom } from '@/models/chatRoom';

export const createChatRoom = async (phoneNumber: string): Promise<ChatRoom> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateChat($phoneNumber: String!) {
        createChat(phoneNumber: $phoneNumber) {
          id
          phoneNumber1
          phoneNumber2
          callerName
          lastMessage
          lastMessageSentAt
          unreadMessagesCount
          isImportant
          isDone
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      phoneNumber,
    },
  });

  const newRoom: ChatRoom = {
    id: response.data!.createChat.id,
    phoneNumber1: response.data!.createChat.phoneNumber1,
    phoneNumber2: response.data!.createChat.phoneNumber2,
    callerName: response.data!.createChat.callerName,
    lastMessage: response.data!.createChat.lastMessage,
    lastMessageSentAt: response.data!.createChat.lastMessageSentAt,
    unreadMessagesCount: 0,
  };

  return newRoom;
};
